import { createApi, fetchBaseQuery, FetchBaseQueryError } from '@reduxjs/toolkit/query/react'
import { AppServices } from 'middleware'
import { GlobalSearchError, GlobalSearchErrorCode, SearchRequest, SearchResponse } from './schema'

export interface GlobalSearchQueryError {
    code: GlobalSearchErrorCode
    message: string
}

export const globalSearchApi = createApi({
    reducerPath: 'globalSearchApi',
    baseQuery: fetchBaseQuery({}),
    endpoints: () => ({}),
})

const extendedGlobalSearchApi = globalSearchApi.injectEndpoints({
    endpoints: (builder) => ({
        search: builder.query<SearchResponse, SearchRequest & { accountSlug: string }>({
            queryFn: async ({ accountSlug, ...request }, api) => {
                try {
                    const data = await AppServices.globalSearchService.search(accountSlug, request, api.signal)
                    return { data }
                } catch (error) {
                    const searchError: GlobalSearchQueryError =
                        error instanceof GlobalSearchError
                            ? { code: error.code, message: error.message }
                            : { code: 'unknown', message: 'Global search failed' }
                    // The endpoint surfaces domain errors; cast through the fetchBaseQuery error shape.
                    return { error: searchError as unknown as FetchBaseQueryError }
                }
            },
        }),
    }),
})

export const { reducer, reducerPath } = globalSearchApi
export const { useSearchQuery } = extendedGlobalSearchApi
